const isArray = (value): boolean => Array.isArray(value)
const isString = (value): boolean => typeof value === 'string' && !isNull(value) && !isUndefined(value)
const isNumber = (value): boolean => typeof value === 'number' && !isNull(value) && !isUndefined(value) && !isNan(Number(value))
const isBoolean = (value): boolean => typeof value === 'boolean' && !isNull(value) && !isUndefined(value)
const isObject = (value): boolean => typeof value === 'object' && !isNull(value) && !isUndefined(value)
const isFunction = (value): boolean => typeof value === 'function' && !isNull(value) && !isUndefined(value)
const isSymbol = (value): boolean => typeof value === 'symbol' && !isNull(value) && !isUndefined(value)
const isUndefined = (value): boolean => value === undefined && !isNull(value) 
const isNull = (value): boolean => value === null  && !isUndefined(value)
const isNan = (value): boolean => Number.isNaN(Number(value))
const isArrayEmpty = (array: any[]): boolean => isArray(array) && !array?.length
const isFile = (value): boolean => value instanceof File

const isPasswordsMatched = (password: string, confirmPassword: string): boolean => password != confirmPassword

const isHaveValue = (value): boolean => isString(value) || isNumber(value) || isBoolean(value) || isObject(value) || isFunction(value) || isSymbol(value) || isArray(value) && value?.length > 0


export const Validations = {
    isString,
    isNumber,
    isBoolean,
    isObject,
    isFunction,
    isSymbol,
    isUndefined,
    isNull,
    isFile,
    isNan,
    isArray,
    isArrayEmpty,
    isHaveValue,
    isPasswordsMatched 
}